import { DepartmentIcon } from './DepartmentIcon.tsx'

/**
 * Topical glyph for a catalog card. Delegates to the department map in
 * DepartmentIcon so a card and its entry in the sidebar rail always show the
 * same glyph; this used to carry its own substring matching, which agreed with
 * the rail only by accident.
 */
export function ArtefactIcon({ department }: { department: string }) {
  return <DepartmentIcon department={department} />
}
